<template>
  <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
    <!-- En-tête de la gamme -->
    <div class="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div class="flex-shrink-0">
            <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-tag text-blue-600"></i>
            </div>
          </div>
          <div>
            <h3 class="text-lg font-semibold text-gray-900">{{ gamme.titre || 'Sans titre' }}</h3>
            <p class="text-sm text-gray-600">Gamme de tailles</p>
          </div>
        </div>

        <div class="flex items-center space-x-2">
          <button
            @click="$emit('edit', gamme)"
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
            title="Modifier la gamme"
          >
            <i class="fas fa-edit mr-2"></i>
            Modifier
          </button>
          <button
            @click="$emit('delete', gamme)"
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
            title="Supprimer la gamme"
          >
            <i class="fas fa-trash mr-2"></i>
            Supprimer
          </button>
        </div>
      </div>
    </div>

    <!-- Section des tailles -->
    <div class="p-6 border-t border-gray-200">
      <div class="flex items-center justify-between mb-4">
        <h4 class="text-md font-medium text-gray-900">Tailles disponibles</h4>
        <div class="text-sm text-gray-500">
          Colonnes d1 à d12
        </div>
      </div>

      <div class="grid grid-cols-6 gap-3">
        <div 
          v-for="(size, index) in sizeColumns" 
          :key="index"
          class="text-center"
        >
          <div 
            class="px-2 py-1 rounded-md text-sm font-medium"
            :class="size ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-500'"
          >
            {{ size || '-' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { GammeComplete } from '@/types'

interface Props {
  gamme: GammeComplete
}

interface Emits {
  (e: 'edit', gamme: GammeComplete): void
  (e: 'delete', gamme: GammeComplete): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

// Extraire les colonnes de tailles
const sizeColumns = computed(() => {
  return [
    props.gamme.d1_FR,
    props.gamme.d2_FR,
    props.gamme.d3_FR,
    props.gamme.d4_FR,
    props.gamme.d5_FR,
    props.gamme.d6_FR,
    props.gamme.d7_FR,
    props.gamme.d8_FR,
    props.gamme.d9_FR,
    props.gamme.d10_FR,
    props.gamme.d11_FR,
    props.gamme.d12_FR,
  ]
})
</script>
